import React, { useState } from "react";
import { isObject } from "lodash";
import { Trans } from "react-i18next";

import {
  Button,
  Input,
  Table,
  Form,
} from "reactstrap";

import { FormGroup } from "components/common";

import { Page, PendingButton } from "components/common";
import { jsonToCsv } from "pages/Xero/Reports/ExportButton";

export default ({ t, payroll }) => {
  const [data, setData] = React.useState(null);

  const initial_form = { 'start_date': (new Date()).toISOString().split('T')[0], 'end_date':'', 'employee_name': '' }

  const [searchForm, setSearchForm] = useState(initial_form)

  const fetchData = async () => {
    payroll.get(`tracks/report`, {params:searchForm}).get("data").then((data)=>{
      setData(data);
    });
  };
  React.useEffect(() => void fetchData(), []);


  const calcTotal = (object) => {
    let total = 0;
    Object.values(object).map((x) => {
      if (isObject(x)) total += calcTotal(x);
      else total += x;
      return null;
    });
    return total;
  };
 

  const submitSearchForm = () => {
    fetchData()
  }

  const resetSearchFields = () => {
    setSearchForm(initial_form)
  }

  const onExport = () => {
    let result = [["Payments Reports"]];
    result.push([""]);
    result.push([t("Month/Year"), t("Tracking"), t("Employee"), t("From Account"), t("Amount")]);
    Object.keys(data).forEach(function (month) {
      Object.keys(data[month]).slice(1, Object.keys(data[month]).length).forEach(function (track) {
        Object.keys(data[month][track]).slice(1, Object.keys(data[month][track]).length).forEach(function (employee) {
          result.push([month, track, employee, data[month][track][employee]['bank_account_name'], data[month][track][employee]['total_cost']]);
        });
      });
    });
    jsonToCsv(result, "Track Reports");
  };

  if (!data) return null;

  return (
    <Page title="Track Reports">

      <div className="filters mb-3 mt-2">
        <div className="row">
          <div className="col-9"> 
            <Form className="form d-flex" onSubmit={(e) => { e.preventDefault(); submitSearchForm(); }}>
              <FormGroup className="mr-2">
                <label><Trans>Employee name</Trans></label>
                <Input
                  type="text"
                  name="serach"
                  className=""
                  value={searchForm.employee_name}
                  onChange={(e) => setSearchForm({ ...searchForm, employee_name: e.target.value })}
                />
              </FormGroup>
              <FormGroup className="mx-2">
                <label><Trans>Period Start</Trans></label>
                <Input
                  type="date"
                  name="date"
                  className=""
                  value={searchForm.start_date}
                  onChange={(e) => setSearchForm({ ...searchForm, start_date: e.target.value })}
                />
              </FormGroup>
              <FormGroup className="mx-2">
                <label><Trans>Period End</Trans></label>
                <Input
                  type="date"
                  name="date"
                  className=""
                  value={searchForm.end_date}
                  onChange={(e) => setSearchForm({ ...searchForm, end_date: e.target.value })}
                />
              </FormGroup>
              <div className="ml-2 d-flex align-items-end">
                <Button color="success" className="mr-2" onClick={submitSearchForm}><Trans>Search</Trans></Button>
                <Button className="mr-2" onClick={resetSearchFields}><Trans>Reset</Trans></Button>
              </div>
            </Form>
          </div>
          <div className="col-3 d-flex align-items-end justify-content-end">
            <PendingButton color="primary" onClick={onExport} className="mr-0">
            <i className="fas fa-file-excel mr-2"></i><Trans>Export</Trans>
            </PendingButton>
          </div>
        </div>
      </div>

      <Table bordered>
        <thead>
          <tr>
            <th>
              <Trans>Month</Trans>/<Trans>Year</Trans>
            </th>
            <th>
              <Trans>Tracking</Trans>
            </th>
            <th>
              <Trans>Employee</Trans>
            </th>
            <th>
              <Trans>From Account</Trans>
            </th>
            <th>
              <Trans>Amount</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(data).map((month, monthIndex) => {
            return (
              <React.Fragment key={monthIndex}>
                {
                  Object.keys(data[month]).slice(1, Object.keys(data[month]).length).map((track, trackIndex) => {
                    return (
                      <React.Fragment key={trackIndex}>
                        {
                          Object.keys(data[month][track]).slice(1, Object.keys(data[month][track]).length).map((employee, idx) => (
                            <tr key={idx}>
                              {trackIndex === 0 && idx === 0 &&
                                <th key={monthIndex} rowSpan={data[month].count}>
                                  {month}
                                </th>
                              }

                              {idx === 0 &&
                                <td rowSpan={data[month][track].count} id={trackIndex}>
                                  {track}
                                </td>}
                              <td>
                                {employee}
                              </td>
                              <td>
                                { data[month][track][employee]['bank_account_name'] || '-' }
                              </td>
                              <td>
                                {Number(data[month][track][employee]['total_cost'] || 0).toFixed(2)}
                              </td>
                            </tr>
                          ))
                        }
                      </React.Fragment>
                    )
                  }
                  )
                }
              </React.Fragment>
            )
          }
          )
          }
        </tbody>
      </Table>
    </Page>
  );
};
